/**
 * If you are adding or removing feature flags from this array, can you please notify
 * an 'Analytics Engineer' from the PMS domain so they can update any event based filters
 * on their end.
 */
export const PMS_ANALYTICS_FLAGS = [];
